import {FinancingRateMatrixCell} from '@dms/api/vehicle';

import {FinancingCellCoordinates} from '../types/FinancingCellCoordinates';
import {FinancingCellRates} from '../types/FinancingCellRates';
import {getFinancingCellKey} from './getFinancingCellKey';

/** Writes the rates into every selected coordinate, replacing whatever those cells held before. */
export function applyRatesToFinancingCells(
  cells: FinancingRateMatrixCell[],
  selection: FinancingCellCoordinates[],
  rates: FinancingCellRates
) {
  const uniqueSelection = Array.from(
    new Map(
      selection.map((coordinates) => [getFinancingCellKey(coordinates), coordinates])
    ).values()
  );
  const selectedKeys = new Set(uniqueSelection.map(getFinancingCellKey));

  return [
    ...cells.filter((cell) => !selectedKeys.has(getFinancingCellKey(cell))),
    ...uniqueSelection.map((coordinates) => ({
      ...coordinates,
      nominalRate: rates.nominalRate,
      apr: rates.apr,
    })),
  ];
}
